<template>
  <div v-if="predList.filter((i) => i.willEndIn).length" class="my-2">
    <div class="row">
      <div
        class="col-md-4"
        v-for="(item, i) in predList.filter((i) => i.willEndIn)"
        :key="i"
      >
        <div class="card overflow-hidden position-relative py-3">
          <div class="card-body overflow-hidden">
            <div class="font-size-24 font-weight-bold text-dark mb-n2">
              {{ Math.floor(item.average) }} / Day
            </div>
            <div class="text-uppercase">
              Predicted to end in {{ Math.floor(item.willEndIn) }} Days
            </div>
            <div class="card-over-flow-icon">
              {{ item.text }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@/utils/analytics/common'
export default {
  name: 'Predictions',
  props: {
    accountData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      common,
      predList: []
    }
  },
  mounted() {
    console.log('dasd')
  },
  methods: {},
  watch: {
    accountData: {
      deep: true,
      immediate: true,
      handler() {
        this.predList = [
          // last 7
          {
            average: this.accountData.average_7_days, // average_7
            willEndIn: this.accountData.perdiction_will_end_in_7_days, // divide average_7
            text: '7'
          },
          // last 30
          {
            average: this.accountData.average_30_days,
            willEndIn: this.accountData.perdiction_will_end_in_30_days,
            text: '30'
          },
          // overall
          {
            average: this.accountData.average,
            willEndIn: this.accountData.perdiction_will_end_in,
            text: 'ALL'
          }
        ]
      }
    }
  }
}
</script>

<style scoped>
.card-over-flow-icon {
  position: absolute;
  right: -8px;
  bottom: -53px;
  font-size: 114px;
  opacity: 0.1;
}
</style>
